export default __webpack_public_path__ + "static/media/BLOCK_HAS_ALERT.21ac01ef.svg";